export default {
    data: function () {
        return {
            pickerOptions: {
                shortcuts: [
                    {
                        text: this.$l10n.__("Semaine dernière"),
                        onClick(picker) {
                            const start = new moment().startOf('week').subtract(1, 'weeks')
                            const end   = new moment().endOf('week').subtract(1, 'weeks')
                            picker.$emit("pick", [start.toDate(), end.toDate()]);
                        }
                    },
                    {
                        text: this.$l10n.__("De ce mois"),
                        onClick(picker) {
                            const start = new moment().startOf('month')
                            const end   = new moment().endOf('month')
                            picker.$emit("pick", [start.toDate(), end.toDate()]);
                        }
                    },
                    {
                        text: this.$l10n.__("Du mois dernier"),
                        onClick(picker) {
                            const start = new moment().subtract(1, 'months').startOf('month')
                            const end   = new moment().subtract(1, 'months').endOf('month')
                            picker.$emit("pick", [start.toDate(), end.toDate()]);
                        }
                    },
                    {
                        text: this.$l10n.__("Des 3 derniers mois"),
                        onClick(picker) {
                            const start = new moment().subtract(3, 'months').startOf('month')
                            const end   = new moment().subtract(1, 'months').endOf('month')
                            picker.$emit("pick", [start.toDate(), end.toDate()]);
                        }
                    },
                    {
                        text: this.$l10n.__("De l'année en cours"),
                        onClick(picker) {
                            const start = new moment().startOf('year')
                            const end   = new moment().endOf('year')
                            picker.$emit("pick", [start.toDate(), end.toDate()]);
                        }
                    },
                    {
                        text: this.$l10n.__("De l'année dernière"),
                        onClick(picker) {
                            const start = new moment().startOf('year').subtract(1, 'years')
                            const end   = new moment().endOf('year').subtract(1, 'years')
                            picker.$emit("pick", [start.toDate(), end.toDate()]);
                        }
                    }
                ]
            }
        };
    }
}